import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AuthService } from '../shared/services/auth.service';

@Component({
    templateUrl: './home-screen.component.html',
    styleUrl: './home-screen.component.scss',

    imports: [
        CommonModule,
    ],
})
export class HomeScreenComponent implements OnInit {
    isAuthenticated = false;

    constructor(
        private authService: AuthService
    ){}

    async ngOnInit(): Promise<void> {
        this.authService.authenticated$.subscribe((result) => {
            this.isAuthenticated = result;
        });
    }

    login(event: Event): void {
        event.preventDefault();
        this.authService.signIn();
    }

    logout(event: Event): void {
        event.preventDefault();
        this.authService.signOut();
    }
}